// extracted by mini-css-extract-plugin
export default {"modal":"styles__modal__BZUVE","text":"styles__text__tw0JG","storybook-btn":"styles__storybook-btn__V_ytJ","storybookBtn":"styles__storybook-btn__V_ytJ"};